<div class="d-flex flex-column-fluid" style="margin-top: 20px; margin-down: 20px">
  <div class="container-fluid" style="padding-right: 0; padding-left: 0">
    <div class="card card-custom">
      <div class="cursor-pointer card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">
            <div class="d-flex align-items-center">
              <a
                class="btn btn-clean btn-hover-light-danger btn-sm btn-icon"
                (click)="this.showTaskList = !this.showTaskList"
              >
                <i class="ki ki-arrow-up" *ngIf="showTaskList"></i>
                <i class="ki ki-arrow-down" *ngIf="!showTaskList"></i>
              </a>
              <div class="d-flex flex-column flex-grow-1 ml-5">
                <a class="text-dark-75 mb-0 font-size-xl font-weight-bolder"
                  >{{ category.name }}({{ category.numberTask }})</a
                >
              </div>
            </div>
          </h3>
        </div>
        <div class="card-toolbar" *ngIf="userObjects && userObjects.length > 0">
          <div
            *ngFor="let x of category.tasks"
            style="margin-right: 8px"
            (click)="filterByUser(getUser(x))"
          >
            <div [matTooltip]="getFullNameList(x)" matTooltipPosition="above">
              <kt-user-photo
                [create]="'false'"
                [size]="30"
                [type]="'object'"
                [editable]="false"
                [user$]="getUser(x)"
              >
              </kt-user-photo>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body" *ngIf="showTaskList">
        <kt-task-list
          [groupedByTemplate]="groupedByTemplate"
          [groupedByTeam]="groupedByTeam"
          [groupedByTag]="groupedByTag"
          [fromPatient]="groupedByPatient"
          [teamId]="groupedByTeam ? category.id : ''"
          [template_id]="groupedByTemplate ? category.id : ''"
          [tagId]="groupedByTag ? category.id : ''"
          [patient_id_for_task_list]="groupedByPatient ? category.id : ''"
          [EntitiesFilteredBy]="tempFilteredEntities"
          [filteredView]="filteredView"
          [fromGroupBy]="true"
        >
        </kt-task-list>
      </div>
    </div>
  </div>
</div>
